import React, {useState} from "react"
  
  const DashboardFiltersContext = React.createContext({
    setSitesData: (_sites) => {},
    cabinetsData: [],
    setCabinetsData: (_sites) => {},
    selectedSites: [],
    setSelectedSites: (_sites) => {},
    selectedCabinets: [],
    setSelectedCabinets: (_sites) => {},
    filterSelection: [],
    setFilterSelection: (_sites) => {},
    isViewStatsEnabled: false, 
    setIsViewStatsEnabled: (_flag) => {},
    currentPage: 'dashboard',
    setCurrentPage: (_page) => {},
    siteDefaultValue: [],
    setSiteDefaultValue: (_site) => {},
    cabinetDefaultValue: [],
    setCabinetDefaultValue: (_cabinet) => {},
  })
  
  export const DashboardFiltersProvider = ({children}) => {
    const [sitesData, setSitesData] = useState([]);
    const [cabinetsData, setCabinetsData] = useState([]);
    const [selectedSites, setSelectedSites] = useState([]);
    const [selectedCabinets, setSelectedCabinets] = useState([]);
    const [siteDefaultValue, setSiteDefaultValue] = useState([]);
    const [cabinetDefaultValue, setCabinetDefaultValue] = useState([]);
    const [filterSelection, setFilterSelection] = useState({});
    const [isViewStatsEnabled, setIsViewStatsEnabled] = useState(false);
    const [currentPage, setCurrentPage] = useState('dashboard');
    const [isResetFilter, setIsResetFilter] = useState(new Date());

    const resetFilter = () => {
      const sites = [{label: 'All Sites', value: 'select-all'}, ...sitesData];
      const kiosks = [{label: 'All Kiosks', value: 'select-all'}, ...cabinetsData];
      setSelectedSites(_selectedSites => sites)
      setSelectedCabinets(_selectedCabinets => kiosks)
      setFilterSelection(_filterSelection => { return {
        sites: sites,
        kiosks: kiosks
      }})
    }

  
    return (
      <DashboardFiltersContext.Provider
        value={{
          sitesData,
          setSitesData,
          cabinetsData,
          setCabinetsData,
          selectedSites,
          setSelectedSites,
          selectedCabinets,
          setSelectedCabinets,
          filterSelection,
          setFilterSelection,
          isViewStatsEnabled, 
          setIsViewStatsEnabled,
          resetFilter,
          isResetFilter,
          setIsResetFilter,
          currentPage,
          setCurrentPage,
          siteDefaultValue, 
          setSiteDefaultValue,
          cabinetDefaultValue, 
          setCabinetDefaultValue
        }}
      >
        {children}
      </DashboardFiltersContext.Provider>
    )
  }
  
  export const useDashboardFiltersContext = () => {
    const context = React.useContext(DashboardFiltersContext)
    if (!context) {
      throw new Error(
        "useDashboardFiltersContext must be used within a DashboardFiltersContextProvider"
      )
    }
    return context
  }
  